import {
    Call,
    CallWithFormData,
    CallWithFormDataFile,
    cleanEmpty,
    downloadBlob,
    objectToFormData,
} from "../../../helpers/fetch";
import { types } from "../../types";
import { startUILoading, stopUILoading } from "../administrador/ui/ui";
import { errorHandler } from "../../../helpers/errorHandler";
import Swal from "sweetalert2";
import { setCalendar, setCalendars } from "../operators/AcademicSchedules";
import { deleteConfirmModal } from "../../../helpers/DeleteValidate";
import { setResponse } from "../../slices/components/SubjectsByStudentApp";

function setCycleParam(params, cycleName, cycle) {
    if (!cycle) return; // Ignorar null o undefined

    if (Array.isArray(cycle)) {
        if (cycle.length > 0) {
            params.set(
                cycleName,
                cycle
                    .map((c) => `${c.year}-${c.sub_cycle}${c?.code ?? ""}`)
                    .join(",")
            );
        }
    } else if (typeof cycle === "object") {
        params.set(
            cycleName,
            `${cycle.year}-${cycle.sub_cycle}${cycle?.code ?? ""}`
        );
    }
}

export const startShowStudents = ({
    //?Filtros obligatorios
    page = 1,
    query = "",
    number_rows = 25, // registros por hoja
    all = false,
    //?Filtros por alumno
    academic_record_id = null,
    status = [],
    is_debtor_documents = null,
    filterStatus = [],
    degree = [],
    curricula = [],

    //? Filtros expecificos
    cycle_ids = [],
    freshman = null,
    hasGroup = null,
    english_level = [],
    student_numbers = null,
    curp_validation = null,
    without_curriculum = false,
    //? Ciclos
    inscription_cycle = null,
    academic_cycle = null,
    account_status_cycle = null,
    // ?Admisiones
    adviser_ids = [],
    inscription_from = null,
    inscription_to = null,
    schools_of_origins_id = null,
    schools_of_origins_type = null,
    country = null,

    withLeads = false,
    with_scholarships = false,
    with_accountStatusWithDebits = false,
    with_graduationOptionsRequirements = false,
    with_documentsRequired = false,
    with_accountStatusInscription = false,

    except = [],
    except_curriculum_level = null,
    filter_by_user_coordinations = false,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        //?Filtros obligatorios
        if (all) {
            params.set("all", 1);
        } else {
            params.set("page", page); //pagina actual
            params.set("q", query); //busqueda en general
            params.set("per_page", number_rows); //Genera en formato de lista sin paginar
        }

        //?Filtros por alumno
        if (academic_record_id) {
            params.set("academic_record_id", academic_record_id);
        }

        if (status) {
            //Filtro de estatus de alumno
            if (status.length === 0) {
                //?Filtro por defecto en caso de no tener nada en los filtros (Admisiones o Students)
                params.set(
                    "status",
                    filterStatus.map((c) => c?.value || c)
                );
            } else {
                params.set(
                    "status",
                    status.map((c) => c?.value || c)
                );
            }
        }
        if ([0, 1].includes(is_debtor_documents)) {
            params.set("is_debtor_documents", is_debtor_documents);
        }
        if (degree) {
            //Filtro de grado de alumno
            params.set(
                "degree",
                degree.map((c) => c.value)
            );
        }
        if (curricula) {
            //Filtro de carrera de alumno
            params.set(
                "curricula",
                curricula.map((c) => c.value)
            );
        }

        //? Filtros expecificos
        if (cycle_ids.length > 0) {
            //obtiene alumnos que tengan los ciclos añadidos
            params.set(
                "cycle_ids",
                cycle_ids.map((s) => s.value)
            );
        }
        if (freshman === 1 || freshman === 0) {
            //Filtro de nuevo ingreso
            params.set("freshman", freshman);
        }
        if (hasGroup === 1 || hasGroup === 0) {
            //Filtro de nuevo ingreso
            params.set("hasGroup", hasGroup);
        }
        if (english_level) {
            //Filtro de nivel de ingles
            params.set(
                "english_level",
                english_level.map((s) => s.value)
            );
        }
        if (student_numbers) {
            //Filtro de lista de matriculas
            params.set(
                "student_numbers",
                student_numbers.map((c) => c.value)
            );
        }
        // if (account_status_cycle) {
        //     params.set(
        //         "account_status_cycle",
        //         `${account_status_cycle.year}-${account_status_cycle.sub_cycle}${account_status_cycle.code}`
        //     );
        // }
        // if (academic_cycle) {
        //     params.set(
        //         "academic_cycle",
        //         `${academic_cycle.year}-${academic_cycle.sub_cycle}`
        //     );
        // }
        if (curp_validation === 1 || curp_validation === 0) {
            // Filtro de CURP validadas
            params.set("curp_validation", curp_validation);
        }

        if (without_curriculum) {
            //? Solo se manda el parametro si es true para que mande solo a los que no tienen , en el otro caso , manda todo
            // Filtro de alumnos sin oferta asignada
            params.set("without_curriculum", without_curriculum);
        }
        // ?Admisiones

        //? Ciclos ------------------------------------------------------------
        Object.entries({
            inscription_cycle,
            academic_cycle,
            account_status_cycle,
        }).forEach(([cycleName, cycleValue]) => {
            setCycleParam(params, cycleName, cycleValue);
        });

        if (adviser_ids) {
            params.set(
                "adviser_ids",
                adviser_ids.map((adviser) => adviser?.value)
            );
        }
        if (inscription_from) {
            params.set("inscription_from", inscription_from);
        }
        if (inscription_to) {
            params.set("inscription_to", inscription_to);
        }
        if (schools_of_origins_id) {
            params.set(
                "schools_of_origins_id",
                schools_of_origins_id.map((school) => school.value).join(",")
            );
        }
        if (schools_of_origins_type) {
            params.set(
                "schools_of_origins_type",
                schools_of_origins_type.map((school) => school.value).join(",")
            );
        }
        if (country) {
            params.set("country", country);
        }

        //? Relaciones
        if (withLeads) {
            params.set("withLeads", withLeads ? 1 : 0);
        }
        if (with_scholarships) {
            params.set("with_scholarships", with_scholarships);
        }
        if (with_accountStatusWithDebits) {
            params.set(
                "with_accountStatusWithDebits",
                with_accountStatusWithDebits
            );
        }
        if (with_graduationOptionsRequirements) {
            params.set(
                "with_graduationOptionsRequirements",
                with_graduationOptionsRequirements
            );
        }
        if (with_documentsRequired) {
            params.set("with_documentsRequired", with_documentsRequired);
        }
        if (with_accountStatusInscription) {
            params.set(
                "with_accountStatusInscription",
                with_accountStatusInscription
            );
        }

        //?Filtros de excepciones
        if (except) {
            params.set(
                "except",
                except.map((s) => s.id)
            );
        }
        if (except_curriculum_level) {
            params.set("except_curriculum_level", except_curriculum_level);
        }

        if (filter_by_user_coordinations) {
            params.set("filter_by_user_coordinations", 1);
        }

        const resp = await Call("students", "GET", params.toString());

        if (resp.success) {
            dispatch(show(resp.success.data));
        }
        dispatch(stopUILoading());
    };
};

export const startShowStudentsSearchBar = ({
    page = 1,
    query = "",
    number_rows = 10,
}) => {
    return async (dispatch) => {
        const params = new URLSearchParams();

        params.set("page", page);
        params.set("q", query);
        params.set("per_page", number_rows);

        const resp = await Call("students", "GET", params.toString());

        if (resp.success) {
            dispatch(searchBar(resp.success.data.data));
        }
    };
};

export const startDelete = (academicRecord, callback = () => {}) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `operators/students/delete/${academicRecord.id}`,
                "DELETE"
            );
            if (resp.success) {
                Swal.fire({
                    title: "Éxito",
                    text: "Registro eliminado.",
                    toast: true,
                    position: "bottom-end",
                    icon: "success",
                });
                callback();
            } else {
                errorHandler(resp, setErrors);
            }

            dispatch(stopUILoading());
        });
    };
};

export const startCreateStudent = (
    values,
    navigate,
    setErrors = null,
    isBasicForm = false
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        values = cleanEmpty(values);

        let formData = objectToFormData(values);

        let url = "students/create";
        if (isBasicForm) {
            url = "students/create/basic";
        }

        const resp = await CallWithFormData(url, "POST", formData);

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
            });

            let student = resp.success;

            dispatch(startStudentSetActive(student));
            dispatch(startStudentCloseForm());
            navigate(`/app/students/form/${student.student_number}`);
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startNewAcademicRecordWithOutStudent = (
    values,
    navigate,
    setErrors = null
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        values = cleanEmpty(values);

        let formData = objectToFormData(values);

        const resp = await CallWithFormData(
            "students/register/academic-record/without-student",
            "POST",
            formData
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
            });

            let student = resp.success;

            dispatch(startStudentSetActive(student));

            navigate(`/app/students/form/${student.student_number}`);
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startAddCycleToStudent = (
    values,
    academic_record,
    setErrors = null,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        values = cleanEmpty(values);

        let formData = objectToFormData({
            ...values,
            academic_record_id: academic_record.id,
        });

        const resp = await CallWithFormData(
            "students/academic_record/cycle",
            "POST",
            formData
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
            });
            dispatch(
                startGetStudentById(
                    academic_record.student_number,
                    null,
                    (updatedAcademicRecord) => {
                        callback(updatedAcademicRecord);
                    }
                )
            );
            // callback();
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDeleteAcademicRecordCycle = (
    academicRecordCycle,
    studentInfo
) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());
            const resp = await Call(
                `students/academic_record/cycle/${academicRecordCycle.id}`,
                "DELETE"
            );

            if (resp.success) {
                dispatch(startGetStudentById(studentInfo.student_number));
                Swal.fire({
                    title: "Éxito",
                    text: "Eliminado correctamente.",
                    icon: "success",
                });
            } else {
                errorHandler(resp);
            }
            dispatch(stopUILoading());
        });
    };
};

export const setCycleView = (cycle_id, academic_record_id) => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());

        const resp = await Call(`operators/cycles/cycle-view`, "POST", {
            academic_record_id: academic_record_id,
            cycle_id: cycle_id,
        });

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Modificación exitosa.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 1000,
            });
            dispatch(UpdateCycles(cycle_id));
        }

        dispatch(stopUILoading());
    };
};

export const startUpdateStudent = (values, setErrors = null) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        delete values.student.academic_records;
        delete values.student.federal_entity_birth;
        delete values.student.uri;

        const { income_average, english_level } = values;

        let formData = objectToFormData({
            ...values.student,
            income_average,
            english_level,
        });

        const resp = await CallWithFormData(
            `students/edit/${values.student_number}`,
            "POST",
            formData
        );

        if (resp.success) {
            dispatch(startStudentSetActive(resp.success));
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startEditWithCurpValidation = (
    student_number,
    curp_validation_id,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `students/edit/curp-validation/${student_number}/${curp_validation_id}`,
            "POST"
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Se realizó la validación de CURP.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });

            callback(resp.success);
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdateAvatar = (student_number, photo) => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());

        let url = "students/update-profile";

        let formData = new FormData();
        formData.append("photo", photo);
        formData.append("student_number", student_number);

        const resp = await CallWithFormData(url, "POST", formData);
        dispatch(startStudentSetActive(resp.success));

        dispatch(stopUILoading());
    };
};

export const startGetStudentById = (
    student_number,
    navigate = null,
    callback = () => {},
    beforeCallback = () => {},
    forSearch = false
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`students/get/${student_number}`);
        beforeCallback();
        if (resp.success) {
            if (forSearch) {
                dispatch(startStudentSetSearchActive(resp.success));
            } else {
                callback(resp.success);
                dispatch(startStudentSetActive(resp.success));
            }
        } else {
            if (!forSearch) {
                if (navigate) {
                    navigate(`/app/students`);
                }
                errorHandler(resp);
            }
        }

        dispatch(stopUILoading());
    };
};

export const startGetStudentByIdWithoutNavigate = (student_number) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`students/get/${student_number}`);
        if (resp.success) {
            dispatch(startStudentSetActive(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startGetGroupsByStudentNumber = (student_number, cycle_id) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.append("student_number", student_number);
        params.append("cycle_id", cycle_id);

        const resp = await Call(
            `students/get/academic_groups`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setGroupsByStudent(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startGenerateCredential = ({ student_number }) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(`students/generate/credential`, "POST", {
            student_number,
        });
        if (resp.success) {
            let url = resp.success.credential;
            let link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", `${student_number}.png`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startOpenPDFPage = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        let url = `/app/students/report/payments/${values.student_number}`;
        window.open(
            url,
            "Reporte pagos de estudiante",
            "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, tittlebar=no, width=900, height=600"
        );
        dispatch(stopUILoading());
    };
};

export const startGenerateXML = (data) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const modality_id = document.getElementsByName("modality_id")[0];
        const modality = modality_id.options[modality_id.selectedIndex].text;

        const funSocialService_id = document.getElementsByName(
            "funSocialService_id"
        )[0];
        const funSocialService =
            funSocialService_id.options[funSocialService_id.selectedIndex].text;

        const recognition_id = document.getElementsByName("recognition_id")[0];
        const recognition =
            recognition_id.options[recognition_id.selectedIndex].text;

        const expedition_federal_entity_id = document.getElementsByName(
            "expedition_federal_entity_id"
        )[0];
        const expedition_federal_entity =
            expedition_federal_entity_id.options[
                expedition_federal_entity_id.selectedIndex
            ].text;

        const history_federal_entity_id = document.getElementsByName(
            "history_federal_entity_id"
        )[0];
        const history_federal_entity =
            history_federal_entity_id.options[
                history_federal_entity_id.selectedIndex
            ].text;

        const historySchool_id =
            document.getElementsByName("historySchool_id")[0];
        const historySchool =
            historySchool_id.options[historySchool_id.selectedIndex].text;

        data = {
            ...data,
            modality,
            funSocialService,
            expedition_federal_entity,
            history_federal_entity,
            historySchool,
            recognition,
        };

        const formData = new FormData();

        formData.append("data", JSON.stringify(data));

        const headers = new Headers({
            "Content-Type": "application/json",
            Accept: "application/json",
        });

        const token = localStorage.getItem("token");
        if (token) {
            headers.append("Authorization", `Bearer ${token}`);
        }

        const options = {
            headers,
            method: "POST",
            body: formData,
        };

        const resp = await fetch(`/api/students/xml/generate/`, options);

        let url = window.URL.createObjectURL(await resp.blob());
        let link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", `${data.id}.xml`);
        document.body.appendChild(link);
        link.click();
        link.remove();

        dispatch(stopUILoading());
    };
};

export const startOpenCURPPage = (curp) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        try {
            // Solicitar permiso al usuario
            await navigator.permissions.query({ name: "clipboard-write" });

            // Si se concede el permiso, copiar al portapapeles y abrir la URL
            await navigator.clipboard.writeText(curp);

            let url = `https://www.gob.mx/curp`;
            window.open(
                url,
                "Validar CURP",
                "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, titlebar=no, width=900, height=600"
            );
        } catch (error) {
            console.error(
                "Error al copiar al portapapeles o solicitar permiso:",
                error
            );
            alert(
                "Ocurrió un error al copiar al portapapeles o solicitar permiso."
            );
        }

        dispatch(stopUILoading());
    };
};

export const startShowStudentsSchedules = (cycle_id) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("cycle_id", cycle_id);

        const resp = await Call(`students/calendar`, "GET", params.toString());

        if (resp.success) {
            dispatch(
                setCalendars(resp.success.calendar, "STUDENT_SCHEDULE_SESSION")
            );
            dispatch(setResponse(resp.success));
        }
        dispatch(stopUILoading());
    };
};

export const startSaveDiscount = (data) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `students/account-status/discount`,
            "POST",
            data
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        }

        dispatch(stopUILoading());
    };
};

export const startSendAccess = (data) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/students/send_access/${data.id}`,
            "POST"
        );

        if (resp.success) {
            const emails = [];
            if (data?.student?.personal_email) {
                emails.push(data.student.personal_email);
            }
            if (data?.student?.institucional_email) {
                emails.push(data.student.institucional_email);
            }

            if (emails.length === 0) {
                Swal.fire({
                    title: "Sin correos registrados",
                    icon: "warning",
                });
            } else {
                Swal.fire({
                    title: "Éxito",
                    text: `Credenciales enviadas exitosamente a los correos: ${emails.join(
                        ", "
                    )}`,
                    icon: "success",
                });
            }
        }

        dispatch(stopUILoading());
    };
};

export const startShowStudentsSocialServices = ({
    number_rows = 25,
    all = 0,
    academic_record = null,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("per_page", number_rows);
        params.set("all", all);

        const resp = await Call(
            `students/services/by/${academic_record}`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(show(resp.success.data));
        }
        dispatch(stopUILoading());
    };
};

export const startShowPaidServices = ({
    number_rows = 25,
    all = 0,
    academic_record,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("per_page", number_rows);
        params.set("all", all);

        const resp = await Call(
            `students/services/by/${academic_record}`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            // dispatch(show(resp.success.data));
        }
        dispatch(stopUILoading());
    };
};

export const startDownloadReport = ({
    page,
    query = "",
    number_rows,
    //?Filtros por alumno
    status = [],
    filterStatus = [],
    degree = [],
    curricula = [],

    //? Filtros expecificos
    cycle_ids = [],
    freshman = null,
    hasGroup = null,
    english_level = [],
    student_numbers = null,
    //? Ciclos
    inscription_cycle = null,
    academic_cycle = null,
    account_status_cycle = null,
    // ?Admisiones
    adviser_ids = [],
    inscription_from = null,
    inscription_to = null,
    schools_of_origins_id = null,
    schools_of_origins_type = null,
    country = null,

    //*Se da el valor inicial de vacio para que por defecto traiga todos
    withLeads = false,
    with_scholarships = false,
    with_accountStatusWithDebits = false,
    with_accountStatusInscription = false,

    except = [],
    except_curriculum_level = null,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("export", 1);
        //?Filtros obligatorios
        params.set("page", page); //pagina actual
        params.set("q", query); //busqueda en general
        params.set("per_page", number_rows); //Genera en formato de lista sin paginar

        //?Filtros por alumno
        if (status) {
            //Filtro de estatus de alumno
            if (status.length === 0) {
                //?Filtro por defecto en caso de no tener nada en los filtros (Admisiones o Students)
                params.set(
                    "status",
                    filterStatus.map((c) => c.value)
                );
            } else {
                params.set(
                    "status",
                    status.map((c) => c.value)
                );
            }
        }
        if (degree) {
            //Filtro de grado de alumno
            params.set(
                "degree",
                degree.map((c) => c.value)
            );
        }
        if (curricula) {
            //Filtro de carrera de alumno
            params.set(
                "curricula",
                curricula.map((c) => c.value)
            );
        }

        //? Filtros expecificos
        if (cycle_ids.length > 0) {
            //obtiene alumnos que tengan los ciclos añadidos
            params.set(
                "cycle_ids",
                cycle_ids.map((s) => s.value)
            );
        }
        if (freshman === 1 || freshman === 0) {
            //Filtro de nuevo ingreso
            params.set("freshman", freshman);
        }
        if (hasGroup === 1 || hasGroup === 0) {
            //Filtro de nuevo ingreso
            params.set("hasGroup", hasGroup);
        }
        if (english_level) {
            //Filtro de nivel de ingles
            params.set(
                "english_level",
                english_level.map((s) => s.value)
            );
        }
        if (student_numbers) {
            //Filtro de lista de matriculas
            params.set(
                "student_numbers",
                student_numbers.map((c) => c.value)
            );
        }
        // if (account_status_cycle) {
        //     params.set(
        //         "account_status_cycle",
        //         `${account_status_cycle.year}-${account_status_cycle.sub_cycle}`
        //     );
        // }
        // if (academic_cycle) {
        //     params.set(
        //         "academic_cycle",
        //         `${academic_cycle.year}-${academic_cycle.sub_cycle}`
        //     );
        // }
        // ?Admisiones

        //? Ciclos ------------------------------------------------------------
        Object.entries({
            inscription_cycle,
            academic_cycle,
            account_status_cycle,
        }).forEach(([cycleName, cycleValue]) => {
            setCycleParam(params, cycleName, cycleValue);
        });

        if (adviser_ids) {
            params.set(
                "adviser_ids",
                adviser_ids.map((adviser) => adviser?.value)
            );
        }
        if (inscription_from) {
            params.set("inscription_from", inscription_from);
        }
        if (inscription_to) {
            params.set("inscription_to", inscription_to);
        }
        if (schools_of_origins_id) {
            params.set(
                "schools_of_origins_id",
                schools_of_origins_id.map((school) => school.value).join(",")
            );
        }
        if (schools_of_origins_type) {
            params.set(
                "schools_of_origins_type",
                schools_of_origins_type.map((school) => school.value).join(",")
            );
        }
        if (country) {
            params.set("country", country);
        }
        //?Relaciones
        if (withLeads) {
            params.set("withLeads", withLeads ? 1 : 0);
        }
        if (with_scholarships) {
            params.set("with_scholarships", with_scholarships);
        }
        if (with_accountStatusWithDebits) {
            params.set(
                "with_accountStatusWithDebits",
                with_accountStatusWithDebits
            );
        }
        if (with_accountStatusInscription) {
            params.set(
                "with_accountStatusInscription",
                with_accountStatusInscription
            );
        }
        //?Filtros de excepciones
        if (except) {
            params.set(
                "except",
                except.map((s) => s.id)
            );
        }
        if (except_curriculum_level) {
            params.set("except_curriculum_level", except_curriculum_level);
        }

        const response = await CallWithFormDataFile(
            `students`,
            "GET",
            params.toString()
        );

        downloadBlob(response, `Reporte de estudiantes`);

        dispatch(stopUILoading());
    };
};

export const startInscriptionStudent = (values, setErrors = null, navigate) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        values = cleanEmpty(values);

        let formData = objectToFormData(values);

        const resp = await CallWithFormData(
            "students/solicitud-ingreso",
            "POST",
            formData
        );

        if (resp.success) {
            let student = resp.success;

            dispatch(startStudentSetActive(student));

            navigate(`/solicitud-ingreso-exitosa`);
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startAddFamily = (
    values,
    studentNumber,
    setErrors = null,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const resp = await Call("students/family/create", "PUT", values);

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
            });

            dispatch(startGetStudentByIdWithoutNavigate(studentNumber));
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdateEnglishLevelByStudent = (
    values,
    academic_record_id,
    setErrors,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        const resp = await Call(
            `operators/students/update/english-level/${academic_record_id}`,
            "PUT",
            values
        );

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startEditFamily = (
    values,
    studentNumber,
    setErrors = null,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `students/family/edit/${values.id}`,
            "PATCH",
            values
        );

        if (resp.success) {
            callback();
            Swal.fire({
                title: "Éxito",
                text: "Registro exitoso.",
                icon: "success",
            });

            dispatch(startGetStudentByIdWithoutNavigate(studentNumber));
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDestroyFamily = (familyId, studentNumber) => {
    return async (dispatch) => {
        const result = await Swal.fire({
            title: "¿Estás seguro de eliminar?",
            icon: "warning",
            text: "No podrás revertir esta acción!",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Si, Eliminar!",
            confirmButtonColor: "#2e4a6c",
            cancelButtonColor: "#6c757d",
            input: "text",
            inputLabel:
                "Escribe la palabra 'eliminar', para confirmar esta operación.",
            inputAttributes: {
                autocapitalize: "off",
            },
        });
        if (result.value === "eliminar") {
            dispatch(startUILoading());

            const resp = await Call(
                `students/family/destroy/${familyId}`,
                "DELETE"
            );
            if (resp.success) {
                Swal.fire({
                    title: "Éxito",
                    text: "Eliminado con Éxito.",
                    icon: "success",
                });

                dispatch(startGetStudentByIdWithoutNavigate(studentNumber));
            } else {
                errorHandler(resp);
            }
        }

        dispatch(stopUILoading());
    };
};

// export const startAddStudentNote = (
//     values,
//     academic_record,
//     setErrors = null
// ) => {
//     return async (dispatch) => {
//         dispatch(startUILoading());

//         const resp = await CallWithFormData(
//             "students/academic_record/notes",
//             "PUT",
//             values
//         );

//         if (resp.success) {
//             Swal.fire({
//                 title: "Éxito",
//                 text: "Registro exitoso.",
//                 icon: "success",
//             });
//             dispatch(startGetStudentById(academic_record.student_number));
//             dispatch(startStudentCloseForm());
//         } else {
//             errorHandler(resp, setErrors);
//         }

//         dispatch(stopUILoading());
//     };
// };

export const startChangeAdmisionCycle = (values) => {
    return async (dispatch, getState) => {
        dispatch(startUILoading());

        const resp = await Call(`operators/cycles/change`, "POST", values);

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Modificación exitosa.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 1000,
            });

            dispatch(updateInscriptionCycleId(resp.success));
        }

        dispatch(stopUILoading());
    };
};

export const startShowStudensOriginSchool = ({
    page = 1,
    query = "",
    number_rows = 25,
    inscription_cycle_id = null,
    schools_of_origins_id = null,
    schools_of_origins_type = null,
    from = null,
    to = null,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("page", page);
        params.set("q", query);
        params.set("per_page", number_rows);

        if (inscription_cycle_id) {
            params.set(
                "inscription_cycle_id",
                inscription_cycle_id.map((cycle) => cycle.value).join(",")
            );
        }
        if (schools_of_origins_id) {
            params.set(
                "schools_of_origins_id",
                schools_of_origins_id.map((school) => school.value).join(",")
            );
        }
        if (schools_of_origins_type) {
            params.set(
                "schools_of_origins_type",
                schools_of_origins_type.map((school) => school.value).join(",")
            );
        }
        if (from) {
            params.set("from", from);
        }
        if (to) {
            params.set("to", to);
        }

        const resp = await Call(
            `students/school-of-origin/show`,
            "GET",
            params.toString()
        );
        if (resp.success) {
            dispatch(startPaginationSchoolsOfOrgin(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startExportStudensOriginSchool = ({
    inscription_cycle_id = null,
    schools_of_origins_id = null,
    schools_of_origins_type = null,
    from = null,
    to = null,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("export", 1);

        if (inscription_cycle_id) {
            params.set(
                "inscription_cycle_id",
                inscription_cycle_id.map((cycle) => cycle.value).join(",")
            );
        }
        if (schools_of_origins_id) {
            params.set(
                "schools_of_origins_id",
                schools_of_origins_id.map((school) => school.value).join(",")
            );
        }
        if (schools_of_origins_type) {
            params.set(
                "schools_of_origins_type",
                schools_of_origins_type.map((school) => school.value).join(",")
            );
        }
        if (from) {
            params.set("from", from);
        }
        if (to) {
            params.set("to", to);
        }

        const resp = await CallWithFormDataFile(
            `students/school-of-origin/show`,
            "GET",
            params.toString()
        );
        downloadBlob(resp, "Reporte de escuelas de procedencia");

        dispatch(stopUILoading());
    };
};

export const startShowCondensedStudensOriginSchool = ({
    inscription_cycle_id = null,
    schools_of_origins_id = null,
    schools_of_origins_type = null,
    from = null,
    to = null,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("isCondensed", 1);

        if (inscription_cycle_id) {
            params.set(
                "inscription_cycle_id",
                inscription_cycle_id.map((cycle) => cycle.value).join(",")
            );
        }
        if (schools_of_origins_id) {
            params.set(
                "schools_of_origins_id",
                schools_of_origins_id.map((school) => school.value).join(",")
            );
        }
        if (schools_of_origins_type) {
            params.set(
                "schools_of_origins_type",
                schools_of_origins_type.map((school) => school.value).join(",")
            );
        }
        if (from) {
            params.set("from", from);
        }
        if (to) {
            params.set("to", to);
        }

        const resp = await Call(
            `students/school-of-origin/show`,
            "GET",
            params.toString()
        );
        if (resp.success) {
            dispatch(startCondensedSchoolsOfOrigin(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startShowCycleStudentsReport = (
    values,
    showSwalNoInformation = false,
    is_export = false
) => {
    return async (dispatch) => {
        dispatch(startUILoading());
        try {
            const {
                cycles = {},
                period,
                status = [],
                is_debtor_documents,
                curriculum_ids = [],
                coordination_ids = [],
                degree = [],
                letter = [],
                gender,
                hide_some_status = 1,
                equivalent,
                documentation,
            } = values || {};

            const params = new URLSearchParams();

            if (cycles?.year != null && cycles?.sub_cycle != null) {
                params.set("cycles", `${cycles.year}-${cycles.sub_cycle}`);
            }

            if (period) params.set("period", period);

            // Ocultar estatus por defecto (DEUDOR DE DOCUMENTOS, SOLICITANTE)
            params.set("hide_some_status", hide_some_status);

            if (Array.isArray(status) && status.length) {
                params.set(
                    "status",
                    status.map((item) => item?.value ?? item).join(",")
                );
            }

            if ([0, 1].includes(is_debtor_documents)) {
                params.set("is_debtor_documents", is_debtor_documents);
            }

            if (Array.isArray(curriculum_ids) && curriculum_ids.length) {
                params.set(
                    "curriculum_ids",
                    curriculum_ids.map((item) => item?.value ?? item).join(",")
                );
            }

            if (Array.isArray(coordination_ids) && coordination_ids.length) {
                params.set(
                    "coordination_ids",
                    coordination_ids
                        .map((item) => item?.value ?? item)
                        .join(",")
                );
            }

            if (Array.isArray(degree) && degree.length) {
                params.set(
                    "degree",
                    degree.map((item) => item?.value ?? item).join(",")
                );
            }

            if (Array.isArray(letter) && letter.length) {
                params.set(
                    "letter",
                    letter.map((item) => item?.value ?? item).join(",")
                );
            }

            if (equivalent) params.set("equivalent", equivalent);
            if (gender) params.set("gender", gender);
            if (documentation) params.set("documentation", documentation);

            const endpoint = "operators/reports/academic-records/by/cycle";

            if (is_export) {
                params.set("export", 1);
                const resp = await CallWithFormDataFile(
                    endpoint,
                    "GET",
                    params.toString()
                );
                downloadBlob(resp, "Reporte de alumnos por ciclo");
            } else {
                const resp = await Call(endpoint, "GET", params.toString());

                if (resp?.success) {
                    if (
                        showSwalNoInformation &&
                        (resp.success?.count ?? 0) === 0
                    ) {
                        Swal.fire({
                            title: "Sin información",
                            text: "No se encontró información de búsqueda con los filtros seleccionados.",
                            toast: true,
                            position: "bottom-end",
                            icon: "warning",
                            timer: 8000,
                        });
                    }
                    dispatch(setCycleStudentsReport(resp.success));
                } else {
                    errorHandler(resp);
                }
            }
        } finally {
            dispatch(stopUILoading());
        }
    };
};

export const startShowLanguageFollowUpReport = (values) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const { cycle, curriculum_id, level, teachers } = values;

        const params = new URLSearchParams();
        params.set("cycle", `${cycle.year}-${cycle.sub_cycle}`);
        params.set("curriculum_id", curriculum_id);
        params.set("level", level);

        if (teachers.length > 0) {
            params.set("teachers", teachers.join(","));
        } else if (teachers) {
            params.set("teachers", teachers);
        }

        const resp = await Call(
            "operators/reports/academic-record-schedule/english",
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setLanguageFollowUpReport(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startDownloadAKardexSingle = ({
    academic_record_id,
    student_number,
    ead_type = null,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        if (ead_type) {
            params.set("ead_type", ead_type);
        }

        const resp = await CallWithFormDataFile(
            `operators/students/grades/generate/kardex/${academic_record_id}`,
            "GET",
            params.toString()
        );

        if (resp.errors || resp.error) {
            errorHandler(resp);
        } else {
            downloadBlob(resp, `Kardex académico - ${student_number}`);
        }

        dispatch(stopUILoading());
    };
};

export const startDownloadAKardexAll = ({
    cycles,
    coordination_ids,
    curriculum_ids,
    status,
    degree,
    letter,
    ead_type = null,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("cycles", `${cycles?.year}-${cycles?.sub_cycle}`);

        if (coordination_ids?.length) {
            params.set(
                "coordination_ids",
                coordination_ids.map((item) => item.value).join(",")
            );
        }

        if (curriculum_ids?.length) {
            params.set(
                "curriculum_ids",
                curriculum_ids.map((item) => item.value).join(",")
            );
        }

        if (status?.length) {
            params.set("status", status.map((item) => item.value).join(","));
        }

        if (degree?.length) {
            params.set("degree", degree.map((item) => item.value).join(","));
        }

        if (letter?.length) {
            params.set("letter", letter.map((item) => item.value).join(","));
        }

        if (ead_type) {
            params.set("ead_type", ead_type);
        }

        const resp = await CallWithFormDataFile(
            "operators/students/grades/generate/kardex/massive",
            "GET",
            params.toString()
        );
        downloadBlob(
            resp,
            `Kardex académicos - ${cycles?.year}-${cycles?.sub_cycle}`
        );

        dispatch(stopUILoading());
    };
};

export const startDownloadReportCardSingle = ({
    academic_record_id,
    student_number,
    cycle_id,
    final = false,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("final", final ? 1 : 0);

        const resp = await CallWithFormDataFile(
            `operators/students/grades/generate/report-card/${academic_record_id}/${cycle_id}`,
            "GET",
            params.toString()
        );

        if (resp.error) {
            errorHandler(resp);
        }

        downloadBlob(
            resp,
            `Boleta${
                final ? " final" : ""
            } de calificaciones - ${student_number}`
        );

        dispatch(stopUILoading());
    };
};

//*Types
export const startStudentSetActive = (student) => ({
    type: types.studentsActive,
    payload: student,
});

export const startStudentSetSearchActive = (student) => ({
    type: types.studentsSearchActive,
    payload: student,
});

export const startUpdateStatus = (status) => ({
    type: types.startUpdateStatus,
    payload: status,
});

export const startUpdateIsDebtorDocuments = (is_debtor_documents) => ({
    type: types.startUpdateIsDebtorDocuments,
    payload: is_debtor_documents,
});

export const startUpdatePositiveBalance = (positiveBalance) => ({
    type: types.startUpdatePositiveBalance,
    payload: positiveBalance,
});

export const startStudentUnsetActive = () => ({
    type: types.studentsUnsetActive,
});

export const startStudentUnsetSearchActive = () => ({
    type: types.studentsUnsetSearchActive,
});

export const startStudentOpenForm = () => ({
    type: types.studentsOpenForm,
});

export const startStudentCloseForm = () => ({
    type: types.studentsCloseForm,
});

export const startStudentOpenFormTags = () => ({
    type: types.studentsOpenFormTags,
});

export const startStudentCloseFormTags = () => ({
    type: types.studentsCloseFormTags,
});
export const startStudentSetTags = (student) => ({
    type: types.studentsTags,
    payload: student,
});
export const setStudentsGroupsList = (list) => ({
    type: types.studentsGroupsList,
    payload: list,
});

export const searchBar = (data) => ({
    type: types.studentsSearchBar,
    payload: data,
});

const show = (data) => ({
    type: types.studentsShow,
    payload: data,
});

export const UpdateCycles = (data) => ({
    type: types.studentCyclesForceView,
    payload: data,
});

export const updateInscriptionCycleId = (data) => ({
    type: types.studentCycleChange,
    payload: data,
});

export const setGroupsByStudent = (data) => ({
    type: types.studentGroups,
    payload: data,
});

export const clearGroupsByStudent = () => ({
    type: types.studentClearGroups,
});

export const startPaginationSchoolsOfOrgin = (data) => ({
    type: types.studentsSchoolsOfOrigin,
    payload: data,
});

export const startCondensedSchoolsOfOrigin = (data) => ({
    type: types.studentsCondensedSchoolsOfOrigin,
    payload: data,
});

export const setCycleStudentsReport = (data) => ({
    type: types.studentsSetCycleStudentsReport,
    payload: data,
});

export const clearCycleStudentsReport = () => ({
    type: types.studentsClearCycleStudentsReport,
});

export const setLanguageFollowUpReport = (data) => ({
    type: types.studentsSetLanguageFollowUpReport,
    payload: data,
});

export const startBlockStudent = (data) => ({
    type: types.studentsBlock,
    payload: !!data,
});

export const startSetActiveCycle = (data) => ({
    type: types.studentsSetActiveCycle,
    payload: data,
});

export const startUpdateStudentIEA = (IEA) => ({
    type: types.startUpdateStudentIEA,
    payload: IEA,
});
